class APIError extends Error {
  constructor(message, code) {
    super(message);
    this.code = code;
  }
}

export { APIError };
export default APIError;
